import React from 'react';
import PropTypes from 'prop-types';
import { Checkbox } from '@prisjakt/ui-inputs';
import * as S from './styles';

const PriceFilters = props => {
  if (!Array.isArray(props.priceFilters)) return null;

  return (
    <>
      {props.priceFilters.map(
        priceFilter =>
          !(priceFilter.showAsQuickFilter && priceFilter.hasPrices) &&
          !priceFilter.hide && (
            <S.PriceFilter key={priceFilter.name}>
              <Checkbox
                name={priceFilter.name}
                checked={priceFilter.checked}
                disabled={!priceFilter.hasPrices}
                onChange={props.onFilterChanged}
                label={priceFilter.shortLabel || priceFilter.label}
              />
            </S.PriceFilter>
          )
      )}
    </>
  );
};

PriceFilters.propTypes = {
  priceFilters: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string.isRequired,
      checked: PropTypes.bool.isRequired,
      label: PropTypes.string.isRequired,
      shortLabel: PropTypes.string,
      hasPrices: PropTypes.bool.isRequired,
      showAsQuickFilter: PropTypes.bool.isRequired,
      hide: PropTypes.bool.isRequired,
    })
  ),
  onFilterChanged: PropTypes.func.isRequired,
};

PriceFilters.defaultProps = {
  priceFilters: [],
};

export default PriceFilters;
